import { render, staticRenderFns } from "./FixConfigDialog.vue?vue&type=template&id=e81129a4&scoped=true"
import script from "./FixConfigDialog.vue?vue&type=script&lang=js"
export * from "./FixConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./FixConfigDialog.vue?vue&type=style&index=0&id=e81129a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81129a4",
  null
  
)

export default component.exports